export const LIGHT_GRAY = "--sw-lightGray-color";
export const STORM_GRAY = "--sw-storm-gray-color";
